export default __webpack_public_path__ + "media/assets/img/expand-more-orange-3c24b36c645b1594a1dd41da28d753c1.svg";